import React, { useMemo, useState } from "react";
import { useOutletContext, Link } from "react-router-dom";
import { useTrends } from "./useRunData";
import { pct, Delta } from "./format";
import { PendingInline } from "./Pending";
import "./TabPrompts.css";

export default function TabPrompts() {
  const { report, reportId } = useOutletContext();
  const prompts = useMemo(() => report.prompts || [], [report.prompts]);
  const { runs: trend, pending } = useTrends(reportId, report.updatedAt);
  const latest = trend[trend.length - 1];
  const prev = trend[trend.length - 2];
  const [sort, setSort] = useState("mentionRate");

  const rows = useMemo(() => {
    const stats = new Map((latest?.byPrompt || []).map((p) => [p.promptNumber, p]));
    const prevStats = new Map((prev?.byPrompt || []).map((p) => [p.promptNumber, p]));
    const list = prompts.map((p) => {
      const s = stats.get(p.number) || {};
      const b = prevStats.get(p.number);
      return {
        number: p.number, text: p.text,
        total: s.total || 0, mentionRate: s.mentionRate || 0, linkRate: s.linkRate || 0,
        delta: b ? (s.mentionRate || 0) - (b.mentionRate || 0) : null,
      };
    });
    if (sort === "number") list.sort((a, b) => a.number - b.number);
    else list.sort((a, b) => (b[sort] - a[sort]) || (a.number - b.number));
    return list;
  }, [prompts, latest, prev, sort]);

  const th = (key, label) => (
    <th className={sort === key ? "sortable sorted" : "sortable"} onClick={() => setSort(key)}>
      {label}
    </th>
  );

  return (
    <div className="tab-prompts">
      <p className="tab-prompts-intro">
        {prompts.length} prompt{prompts.length === 1 ? "" : "s"} tracked
        {latest ? `, scored on run #${latest.runNumber}` : ""}. Click a prompt for per-model
        history. Edit prompts in the Settings tab.
        {pending && <PendingInline />}
      </p>
      <table className="runs-table tab-prompts-table">
        <thead>
          <tr>
            {th("number", "#")}
            <th>Prompt</th>
            <th>Responses</th>
            {th("mentionRate", "Mentions")}
            {th("linkRate", "Links")}
            <th>Change</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.number}>
              <td className="tab-prompts-number">#{r.number}</td>
              <td>
                <Link className="tab-prompts-link" to={`/gpt-seo-tracking/reports/${reportId}/prompts/${r.number}`}
                      state={{ promptText: r.text }}>
                  {r.text}
                </Link>
              </td>
              <td>{pending ? "…" : latest ? r.total : "—"}</td>
              <td>{pending ? "…" : latest ? pct(r.mentionRate) : "—"}</td>
              <td>{pending ? "…" : latest ? pct(r.linkRate) : "—"}</td>
              <td>{pending ? "…" : <Delta value={r.delta} />}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
